import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class QueryParamsService {
  constructor(
    private route: ActivatedRoute,
    private injector: Injector
  ) {}

  readParams(target: any) {
    if (target) {
      const paramValues = { ...this.route.snapshot.queryParams };
      for (let key in paramValues) {
        const value = paramValues[key];
        if (target[key] !== paramValues[key]) target[key] = paramValues[key];
      }
    }
  }
}
